import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { HomeComponent } from './home/home.component';
import { RouterModule } from '@angular/router';
import { CommonService } from './common.service';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AboutComponent } from './about/about.component';
import { GoogleAnalyticsService } from './google-analytics.service';
import { ConfigService } from './config.service';
import { SearchComponent } from './search/search.component';
import { SearchPaginationComponent } from './search-pagination/search-pagination.component';
import { SearchResultCardComponent } from './search-result-card/search-result-card.component';
import { HeaderSearchComponent } from './header-search/header-search.component';
import { HomeLinksComponent } from './home-links/home-links.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayModule } from '@angular/cdk/overlay';
import { TrainingCoursesComponent } from './training-courses/training-courses.component';
import { EbiHeaderComponent } from './ebi-header/ebi-header.component';
import { EbiFooterComponent } from './ebi-footer/ebi-footer.component';
import { VfEbiFooterComponent } from './vf-ebi-footer/vf-ebi-footer.component';
import { FooterComponent } from "./footer/footer.component"
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from './shared.module';
import { NgMaterialModule } from './ngmaterial.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { NgxPaginationModule } from 'ngx-pagination';
import { ReleaseNotesComponent } from './release-notes/release-notes.component';
import { PortalCardComponent } from './portal-card/portal-card.component';
import { BrowseDataCarouselComponent } from './browse-data-carousel/browse-data-carousel.component';

@NgModule({
  declarations: [
    AppComponent,
    AppHeaderComponent,
    HomeComponent,
    AboutComponent,
    SearchComponent,
    SearchPaginationComponent,
    SearchResultCardComponent,
    HeaderSearchComponent,
    HomeLinksComponent,
    TrainingCoursesComponent,
    EbiFooterComponent,
    EbiHeaderComponent,
    FooterComponent,
    ReleaseNotesComponent,
    PortalCardComponent,
    BrowseDataCarouselComponent
  ],
  exports: [RouterModule],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    CommonModule,
    OverlayModule,
    NgOptimizedImage,
    VfEbiFooterComponent,
    SharedModule,
    NgMaterialModule,
    NgxPaginationModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    ...(!environment.production ? [StoreDevtoolsModule.instrument({ maxAge: 25 })] : []),
  ],
  providers: [
    CommonService,
    GoogleAnalyticsService,
    ConfigService,
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideClientHydration(withEventReplay()),
  ],
})

export class AppModule {}
